import GameModel from "./GameModel";
import State from "./State";

export default class GameStateControl extends GameModel {
    /**
     * @abstract
     */
    constructor() {
        super();

        /**
         * @constant
         * @type {number}
         */
        this.CALLBACK_GAME_RESET = 1;
        /**
         * @constant
         * @type {number}
         */
        this.CALLBACK_GAME_DELETE = 2;
        /**
         * @constant
         * @type {number}
         */
        this.CALLBACK_GAME_IMPORT = 3;
        /**
         * @constant
         * @type {number}
         */
        this.CALLBACK_GAME_PRESTIGE = 4;

    }

    /**
     * @abstract
     * @returns {State}
     */
    getState() {
        return null; 
    }

    /**
     * @abstract
     */
    startGame() {
    }


    ////////////////////////////////////////////////

    /**
     * @abstract
     */
    prestigeGame() {
    }

    /**
     * @abstract
     */
    resetGame() {
    }

    /**
     * @abstract
     */
    deleteGame() {        
    }

    /**
     * @abstract
     * @param {string} saveStateText 
     */
    importSave(saveStateText) {
    }

    /**
     * @abstract
     * @param {number} callbackCode 
     */
    modelLoadCallback(callbackCode) {
    }
}